import styled, { css } from 'styled-components';
import { styles } from '../constants/styles.js';
import { boxStyles } from '../Box/styles.js';
import { contentTextStyles } from '../ContentText/styles.web.js';
import { tinycolor } from '@ctrl/tinycolor';
import { visitedLighten, visitedDarken } from '../utils/helpers/style.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';
import { generateColorLuminances } from '../utils/helpers/generateColorLuminances.js';

var link = /*#__PURE__*/styled.a.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__link",
  componentId: "sc-1si9cpz-0"
})(["", ";text-decoration:", ";color:", ";text-decoration-thickness:", ";&:focus-visible{outline-offset:0;box-shadow:0 0 0 4px ", ";outline:2px solid ", ";}&:focus:not(:focus-visible){outline:none;box-shadow:none;}&:hover{color:", ";text-decoration-thickness:", ";}", " transition:color ", ";transition-timing-function:", ";&:hover{cursor:pointer;text-decoration:underline;}", ";"], contentTextStyles, function (props) {
  return props.$noUnderline ? 'none' : 'underline';
}, function (props) {
  return generateColorLuminances('normal', props.theme, {
    color: props.$color
  }).bg;
}, function (props) {
  return props.theme.link.web.underlineThickness["default"];
}, function (p) {
  return p.theme.tokens.focus.primary;
}, function (p) {
  return p.theme.tokens.focus.secondary;
}, function (props) {
  return generateColorLuminances('hover', props.theme, {
    color: props.$color
  }).bg;
}, function (props) {
  return props.theme.link.web.underlineThickness.hover;
}, function (props) {
  return !props.$disableVisited ? css(["&:visited{color:", ";}"], function () {
    var bg = tinycolor(props.theme.colors.background);
    var color = tinycolor(props.$color);
    return bg.isDark() ? color.lighten(visitedLighten).toHexString() : color.darken(visitedDarken).toHexString();
  }) : undefined;
}, styles.transition.timing.base, styles.transition["function"].base, boxStyles);

export { link };
